import { combineReducers } from "redux";
import auth from "./authReducer";
import farmReducer from "./farmReducer";
import messagesReducer from "./messagesReducer";

const rootReducer = combineReducers({
  auth,
  messages: messagesReducer,
  farmer: farmReducer
});

export default rootReducer;
